'use client';

import type { FeatureFlagKey } from 'product-analytics';
import useFeatureFlag from '../useFeatureFlag';
function useFeatureFlagMatches(name, value, skipWhile) {
  const featureFlag = useFeatureFlag(name, skipWhile);
  if (typeof featureFlag === "undefined") {
    return;
  }
  return featureFlag === value;
}
export default useFeatureFlagMatches;